import {
    chakra, Button, Text
} from '@chakra-ui/react';

export const Container = chakra(Button, {
    label: 'ThreeEssentialsButton - Container',
    baseStyle: {
        h: '40px',
        borderRadius: '40px',
        p: '10px 16px',
        gap: '16px',
        boxShadow: 'none !important',
        background: 'linear-gradient(104deg, #00ABE8 -2.03%, #007ACC 43.7%, #0063A7 105.46%)',
        maxW: 'fit-content',
        _hover: { background: 'linear-gradient(102.49deg, #007ACC 0%, #014B8B 100%)' },
        _active: { background: 'linear-gradient(102.49deg, #014B8B 0%, #014B8B 100%)' }
    }
});

export const Title = chakra(Text, {
    label: 'ThreeEssentialsButton - Title',
    baseStyle: {
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '24px',
        color: 'white.0'
    }
});

